import { render, staticRenderFns } from "./houseResourceIndex.vue?vue&type=template&id=485f01cf&scoped=true&"
import script from "./houseResourceIndex.vue?vue&type=script&lang=js&"
export * from "./houseResourceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485f01cf",
  null
  
)

export default component.exports